import * as Yup from 'yup';

export const InitialFeedbackPrefSchema = Yup.object({
  showInitialFeedbackPrompt: Yup.boolean().test(
    (val) => val === true
  ),
});


export type InitialFeedbackPrefDataType = Yup.InferType<typeof InitialFeedbackPrefSchema>;

export const initialFeedbackPrefInitialValues: InitialFeedbackPrefDataType = {
  showInitialFeedbackPrompt: false,
};
